// import external dependencies
import 'jquery';

// Import everything from autoload
import "./autoload/_bootstrap.js";

import "jquery.scrollto";
import "jquery.localscroll";

// import local dependencies
import Router   from './util/Router';
import common           from './routes/common';
import home             from './routes/home';
import templateProducts from './routes/products';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // Products page
  templateProducts,
  // About Us page, note the change from about-us to aboutUs.
  //aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// $('#myTabs li.first').addClass('active');
//
$('#myTabs a.so-link').click(function (e) {
  e.preventDefault();
  $('#myTabs li.first').removeClass('active');
  $(this).tab('show');
})

$('#myTabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
  e.target // newly activated tab
  e.relatedTarget // previous active tab
  $(this).parent().addClass('active');
});

$('#myTabs a[data-toggle="tab"]').on('hidden.bs.tab', function (e) {
  e.target // newly activated tab
  e.relatedTarget
  $(this).parent().removeClass('active');
})



// WEBPACK FOOTER //
// ./scripts/main.js